'use client'

import React from 'react'
import HeaderFinal from '../components/HeaderFinal'
import Footer from '../components/Footer'

const OpinionesPage = () => {
  const testimonios = [
    {
      id: 1,
      nombre: 'María González',
      fecha: 'Marzo 2026',
      rating: 5,
      texto: '¡Increíble experiencia! Celebré mi cumpleaños 30 con Airlovers y fue el mejor regalo. Los instructores son profesionales y te hacen sentir seguro en todo momento. Las vistas del Embalse del Tominé son espectaculares. ¡100% recomendado!',
      tipo: 'Cumpleaños',
      foto: '👩‍🦰'
    },
    {
      id: 2,
      nombre: 'Carlos Rodríguez',
      fecha: 'Febrero 2026',
      rating: 5,
      texto: 'Hice la propuesta de matrimonio en el aire y fue mágico. El equipo de Airlovers coordinó todo perfectamente. Mi ahora esposa dijo que sí entre lágrimas de emoción. Un momento que nunca olvidaremos. Gracias por hacerlo posible.',
      tipo: 'Propuesta',
      foto: '👨‍🦱'
    },
    {
      id: 3,
      nombre: 'Ana y Pedro',
      fecha: 'Enero 2026',
      rating: 5,
      texto: 'Celebramos nuestro 5to aniversario con el vuelo Pro Max. Las acrobacias fueron adrenalina pura pero siempre nos sentimos seguros. El video GoPro quedó espectacular. Definitivamente volveremos para nuestro próximo aniversario.',
      tipo: 'Aniversario',
      foto: '👫'
    },
    {
      id: 4,
      nombre: 'Grupo de amigos',
      fecha: 'Diciembre 2025',
      rating: 5,
      texto: 'Fuimos 8 amigos para una despedida de soltero. El descuento grupal fue excelente y la atención fue personalizada. Todos volamos y compartimos una experiencia única. La organización fue impecable desde la reserva hasta el vuelo.',
      tipo: 'Grupo',
      foto: '👥'
    },
    {
      id: 5,
      nombre: 'Laura Martínez',
      fecha: 'Noviembre 2025',
      rating: 5,
      texto: 'Siempre tuve miedo a las alturas pero los instructores de Airlovers me hicieron sentir tan segura que disfruté cada segundo. El proceso de reserva fue fácil y claro. Llegar temprano fue clave para aprovechar el buen clima.',
      tipo: 'Primera vez',
      foto: '👩'
    },
    {
      id: 6,
      nombre: 'Familia Pérez',
      fecha: 'Octubre 2025',
      rating: 5,
      texto: 'Llevamos a nuestros hijos de 12 y 14 años y fue una experiencia familiar increíble. Los niños estaban emocionados y los instructores fueron muy pacientes con ellos. Las medidas de seguridad son excelentes. Volveremos seguro.',
      tipo: 'Familiar',
      foto: '👨‍👩‍👧‍👦'
    },
    {
      id: 7,
      nombre: 'Empresa Tech Solutions',
      fecha: 'Septiembre 2025',
      rating: 5,
      texto: 'Organizamos un team building para 15 empleados. Airlovers manejó todo profesionalmente. La logística fue perfecta, el equipo de instructores excelente y la experiencia unificó al equipo como nunca. Muy recomendado para empresas.',
      tipo: 'Corporativo',
      foto: '🏢'
    },
    {
      id: 8,
      nombre: 'Juan y Sofía',
      fecha: 'Agosto 2025',
      rating: 5,
      texto: 'Regalamos un bono a nuestros padres para su aniversario de bodas y fue un éxito total. A pesar de sus 60 años, disfrutaron como niños. El equipo fue muy atento y cuidadoso. Un regalo que superó todas las expectativas.',
      tipo: 'Regalo',
      foto: '🎁'
    }
  ]

  const stats = [
    { label: 'Vuelos realizados', value: '15,000+' },
    { label: 'Seguridad garantizada', value: '100%' },
    { label: 'Calificación promedio', value: '4.9/5' },
    { label: 'Clientes satisfechos', value: '98%' }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-purple-900 to-black text-white">
      <HeaderFinal />
      
      {/* Hero Section */}
      <div className="relative pt-24 pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              OPINIONES REALES
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Lo que dicen nuestros clientes sobre su experiencia en Airlovers
            </p>
          </div>

          {/* Estadísticas */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
                <div className="text-3xl md:text-4xl font-bold text-blue-300 mb-2">{stat.value}</div>
                <div className="text-white/80">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Testimonios */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {testimonios.map((testimonio) => (
              <div key={testimonio.id} className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 border border-white/20 hover:border-blue-400/50 transition-all duration-300">
                {/* Header del testimonio */}
                <div className="flex items-center mb-4">
                  <div className="text-3xl mr-4">{testimonio.foto}</div>
                  <div>
                    <h3 className="text-xl font-bold">{testimonio.nombre}</h3>
                    <div className="flex items-center">
                      <div className="text-yellow-400 mr-2">
                        {'★'.repeat(testimonio.rating)}
                      </div>
                      <span className="text-white/60 text-sm">{testimonio.fecha}</span>
                    </div>
                  </div>
                </div>
                
                {/* Tipo de experiencia */}
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-blue-900/50 text-blue-300 rounded-full text-sm">
                    {testimonio.tipo}
                  </span>
                </div>
                
                {/* Texto del testimonio */}
                <p className="text-white/90 mb-6">{testimonio.texto}</p>
                
                {/* Rating visual */}
                <div className="flex items-center justify-between">
                  <div className="text-yellow-400 text-lg">
                    {'★'.repeat(testimonio.rating)}
                    <span className="text-white/40 ml-1">{'☆'.repeat(5 - testimonio.rating)}</span>
                  </div>
                  <div className="text-white/60 text-sm">
                    {testimonio.rating}.0/5.0
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Llamado a la acción */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-blue-900/40 to-purple-900/40 rounded-3xl p-8 border border-blue-500/30">
              <div className="text-center">
                <h2 className="text-3xl font-bold mb-6">¿LISTO PARA TU EXPERIENCIA?</h2>
                <p className="text-xl text-white/80 mb-8">
                  Únete a los miles de clientes satisfechos que han vivido la aventura Airlovers
                </p>
                
                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                  <a
                    href="https://wa.me/573028309637?text=¡Hola!%20Quiero%20reservar%20mi%20experiencia%20Airlovers%20después%20de%20ver%20las%20opiniones"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-2xl font-bold hover:shadow-2xl transition-all duration-300"
                  >
                    <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
                    </svg>
                    RESERVAR POR WHATSAPP
                  </a>
                  
                  <a
                    href="/"
                    className="inline-flex items-center justify-center px-8 py-4 bg-white/10 text-white rounded-2xl font-bold border border-white/30 hover:bg-white/20 transition-all duration-300"
                  >
                    VER MÁS EXPERIENCIAS
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Sección de confianza */}
          <div className="max-w-4xl mx-auto mt-16">
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
              <h2 className="text-2xl font-bold mb-6 text-center">🏆 NUESTRO COMPROMISO</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="text-4xl mb-4">🛡️</div>
                  <h3 className="text-xl font-bold mb-2">Seguridad Primero</h3>
                  <p className="text-white/70">Equipo certificado y protocolos de seguridad estrictos</p>
                </div>
                <div className="text-center">
                  <div className="text-4xl mb-4">⭐</div>
                  <h3 className="text-xl font-bold mb-2">Calidad Garantizada</h3>
                  <p className="text-white/70">Instructores con más de 15 años de experiencia</p>
                </div>
                <div className="text-center">
                  <div className="text-4xl mb-4">😊</div>
                  <h3 className="text-xl font-bold mb-2">Satisfacción 100%</h3>
                  <p className="text-white/70">Tu felicidad es nuestra prioridad número uno</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default OpinionesPage